import { Helmet } from 'react-helmet-async';
// sections
import { Chat } from '../sections/@dashboard/chat';
import {Atendetentes} from "../sections/@dashboard/Atendentes";
import {CadastroRS} from "../sections/auth/CadastroRS";



export default function CadastreRSPage() {
  return (
    <>
      <Helmet>
        <title>Cadastre-se como Herói - Eyhe Maior Comunidade de Suporte Emocional do Brasil </title>
      </Helmet>

      <CadastroRS />
    </>
  );
}
